import {debounce} from 'debounce';

export function preventDuplicatedSubmit(func, waitMilliseconds) {
  return debounce(func, waitMilliseconds, true);
}
